module.exports = __webpack_public_path__ + "static/img/account_icon8.6e4b5abf.png";